// @nav-catalog
// Flat page catalog — the single source of navigation IDENTITY. Grouping and
// region membership live in src/navigation/navMenus.ts; icons/placement in
// src/navigation/navConfig.ts. `code` is the stable uuid shared by the router
// handle (routeFor), the RBAC rules (rbac_rules/*.json) and menu refs.
export interface MfeRoutePage {
  label: string;
  path: string;
  code: string;       // stable UUID — router handle + RBAC + menu refs
  pageFile?: string;  // e.g. "src/pages/MembersPage.tsx"
}

// Back-compat aliases: some callers still import these names. In the flat
// catalog every node IS a page, so both resolve to MfeRoutePage.
export type MfeRouteLeaf = MfeRoutePage;
export type MfeRouteNode = MfeRoutePage;

/** Always false — grouping lives in navMenus.ts (kept for legacy walkers). */
export const isGroup = (_n: MfeRouteNode): boolean => false;

export const mfeRoutes: MfeRoutePage[] = [
  {
    "label": "Dashboard",
    "path": "/",
    "code": "454e06c6-f4e4-559f-89d9-acf6fb04a250",
    "pageFile": "src/pages/DashboardPage.tsx"
  },
  {
    "label": "Members",
    "path": "/members",
    "code": "a3eb7c8d-50a2-567a-9d90-1e257cedbdbe",
    "pageFile": "src/pages/MembersPage.tsx"
  },
  {
    "label": "Member Detail",
    "path": "/members/:memberId",
    "code": "91f6fa70-5486-50e5-9f56-9d3e492fd489",
    "pageFile": "src/pages/MemberDetailPage.tsx"
  },
  {
    "label": "New Member",
    "path": "/members/new",
    "code": "c555c1ef-ee57-52f7-be3d-c40571c06999",
    "pageFile": "src/pages/MemberNewPage.tsx"
  },
  {
    "label": "Member Analytics",
    "path": "/member-analytics",
    "code": "46345a0f-db90-5f74-af04-d255251ad733",
    "pageFile": "src/pages/MemberAnalyticsPage.tsx"
  },
  {
    "label": "Member Activity Log",
    "path": "/member-activity-log",
    "code": "ef61337c-c259-53f3-a4c7-013a12edc838",
    "pageFile": "src/pages/MemberActivityLogPage.tsx"
  },
  {
    "label": "Member Population",
    "path": "/member-population",
    "code": "14816726-8ad6-525b-8364-2b7ff5962c68",
    "pageFile": "src/pages/MemberPopulationPage.tsx"
  },
  {
    "label": "Non-Members",
    "path": "/non-members",
    "code": "f5088dc4-c63f-571a-9e93-ad9e51ae2af1",
    "pageFile": "src/pages/NonMembersPage.tsx"
  },
  {
    "label": "Employees",
    "path": "/employees",
    "code": "e88f16fa-bb61-5f6b-8456-3585b6ffbba0",
    "pageFile": "src/pages/EmployeesPage.tsx"
  },
  {
    "label": "Employee Activity Log",
    "path": "/employee-activity-log",
    "code": "5fce6891-2aa5-52ec-ba17-6d41e34c0cc0",
    "pageFile": "src/pages/EmployeeActivityLogPage.tsx"
  },
  {
    "label": "Yellow Page",
    "path": "/yellow-page",
    "code": "43922bc6-bfbd-5080-9d60-27d135381a73",
    "pageFile": "src/pages/YellowPagePage.tsx"
  },
  {
    "label": "Yellow Page Categories",
    "path": "/yellow-page-categories",
    "code": "528e962d-d0fe-5163-9a8d-8f230f8d837a",
    "pageFile": "src/pages/YellowPageCategoriesPage.tsx"
  },
  {
    "label": "Provinces",
    "path": "/provinces",
    "code": "ac12d873-6f36-5c5f-a91c-954fbd787a53",
    "pageFile": "src/pages/ProvincesPage.tsx"
  },
  {
    "label": "Cities",
    "path": "/cities",
    "code": "0581ec1c-4607-5c9a-b7e0-e94245dcca16",
    "pageFile": "src/pages/CitiesPage.tsx"
  },
  {
    "label": "Barangays",
    "path": "/barangays",
    "code": "c8d775c2-9e1d-50c1-bbc5-e497daa25df3",
    "pageFile": "src/pages/BarangaysPage.tsx"
  },
  {
    "label": "Configuration",
    "path": "/configuration",
    "code": "92286bb7-0541-55a5-b257-1777f0d84146",
    "pageFile": "src/pages/ConfigurationPage.tsx"
  },
  {
    "label": "Profile",
    "path": "/profile",
    "code": "4afa1779-1e25-5d6e-afc5-915462fb8094",
    "pageFile": "src/pages/ProfilePage.tsx"
  },
  {
    "label": "Change Password",
    "path": "/profile/password",
    "code": "a88d9181-9099-5276-b24b-da18e1670bc2",
    "pageFile": "src/pages/ProfilePasswordPage.tsx"
  }
];

/** The catalog entry for a path, or undefined when the path is not a nav page. */
export const routeFor = (path: string): MfeRoutePage | undefined =>
  mfeRoutes.find((r) => r.path === path);

export default mfeRoutes;
